<template>
  <article>
    <h2 v-if="title" class="mb-5 text-black text-lg font-bold leading-none uppercase md:text-xl lg:mb-6 lg:text-2xl xl:text-3xl">{{ title }}</h2>
    <div class="grid grid-cols-1 lg:gap-x-8 lg:grid-cols-2">
      <div class="mission-video-shadow-container lg:col-start-1 lg:row-end-4 lg:row-start-1 lg:mb-0" :class="{ 'mb-6': items.length }">
        <div class="mission-video-shadow relative">
          <figure v-if="image" class="rounded-xl overflow-hidden">
            <MoleculePicture class="relative z-20" :image="image" />
          </figure>
          <div v-else-if="embed && embed.url" class="aspect-video rounded-xl overflow-hidden" v-html="embed.code" />
          <p v-if="caption" class="relative z-10 ml-20 pb-4 pt-4 font-bold border-b border-white">
            {{ caption }}
          </p>
        </div>
      </div>
      <div class="row-end-2 row-start-1 lg:col-start-2 lg:pt-3 lg:px-8">
        <h2 v-if="subtitle" class="text-black mb-1 font-bold leading-tight uppercase md:mb-3 md:text-lg lg:text-xl xl:text-2xl">{{ subtitle }}</h2>
        <div class="prose prose--app mb-8 md:text-lg xl:mb-12" v-html="description" />
      </div>
      <div class="lg:col-start-2 lg:row-start-2 lg:px-8">
        <slot name="references">
          <ul class="pl-5 lg:pl-0">
            <li v-for="(item, key) in items" :key="key" :class="{ 'mb-4': key < items.length - 1 }">
              <h3 class="text-lg font-bold">{{ item.label }}</h3>
              <AtomLinkWithIcon v-if="item.title" class="text-lg" :url="item.url" :title="item.title">
                {{ item.title }}
              </AtomLinkWithIcon>
            </li>
          </ul>
        </slot>
      </div>
    </div>
  </article>
</template>

<script setup lang="ts">
interface Props {
  embed: {
    url?: string | null
    code?: string | null
  }
  image?: object // Define properties of Image appropriately based on use
  caption?: string | null
  title?: string
  subtitle?: string
  description: string
  items?: {
    label: string
    title?: string
    url?: string
  }[]
}

withDefaults(defineProps<Props>(), {
  image: () => undefined,
  caption: null,
  title: undefined,
  subtitle: undefined,
  items: () => [],
})
</script>

<style lang="scss" scoped>
.mission-video-shadow-container {
  @apply pb-5 pr-5;

  @screen lg {
    @apply pb-10 pr-10;
  }
}

.mission-video-shadow {
  @apply relative;

  &::before {
    content: ' ';
    top: theme('spacing.5');
    z-index: -1;
    margin-right: -20px;
    @apply w-full bg-app-green-200 rounded-xl absolute h-full right-0;

    @screen lg {
      top: theme('spacing.10');
      margin-right: -40px;
    }
  }
}
</style>

<style lang="scss">
// unscoped scss to style the iframe
.mission-video-shadow {
  iframe {
    @apply rounded-xl w-full h-full;
  }
}
</style>
